import type { User } from './types';

/** Which portal a client app represents. Set per-app at build time. */
export type PortalType = 'members' | 'providers';

/**
 * Role → portal admission rule, mirroring the backend: the Members
 * portal admits `member`; the Providers portal admits `provider` and `staff`.
 *
 * The backend is the authoritative enforcement boundary at login; this drives
 * the client-side guard that stops an already-signed-in user from operating the
 * wrong portal (the auth cookie is shared across portals via the common API host).
 * A user with no resolved role is denied (fail closed).
 */
export function isRoleAllowedOnPortal(userType: User['userType'], portalType: PortalType): boolean {
  switch (portalType) {
    case 'members':
      return userType === 'member';
    case 'providers':
      return userType === 'provider' || userType === 'staff';
  }
}
